import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-14bd54e5")
const _hoisted_1 = {
  id: "meta",
  class: "_main"
}
const _hoisted_2 = { class: "_header" }
const _hoisted_3 = { class: "_headerBack" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { class: "_headerText" }, " Policies ", -1)
const _hoisted_5 = { class: "section" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<h1 class=\"header\" data-v-14bd54e5> Our Policies </h1><div class=\"_content\" data-v-14bd54e5><p data-v-14bd54e5> Last updated 2nd Jan 2022 </p><p data-v-14bd54e5> Thank you for taking the time to explore our policies. We work hard to maintain our documentation and uphold a high standard for our users. If you have any questions or concerns that are not explicitly outlined in our policies, please feel free to email us through the contact provided below. </p></div><h2 class=\"subheader\" data-v-14bd54e5> Vocabulary </h2><div class=\"_content\" data-v-14bd54e5><p data-v-14bd54e5> Within the terms and policies described henceforth, including our terms of use, cookie policy, and privacy policy, the terms &quot;we&quot;, &quot;us&quot;, and &quot;our&quot; refer to the executive body overseeing and managing gochase.me, its website at https://gochase.me and associated subdirectories (&quot;Websites&quot;), and the gochase.me progressive web application (&quot;PWA&quot;) installed through the use of our online application/website. As our website is intended for an English speaking audience, all terms and policies are written in English. </p></div><h2 class=\"subheader\" data-v-14bd54e5> Our services </h2>", 5)
const _hoisted_11 = { class: "_content" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, "Gochase.me makes use of the following services: Vercel for frontend application provision; Google's Firebase for our database, server functions, and authentication system; Facebook for user account credentialing (managed by Firebase); Amazon Web Services (AWS) for storing and serving images used in our games, and PayPal for managing payments at our storefront. Accordingly, we store personal data and utilise cookies for service provision and core application functionality. Please explore our policies below for specific information.", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h4", null, "Our terms and policies", -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Terms of Service")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Cookie Policy")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Privacy Policy")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Progressive Web Application")
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h2", { class: "subheader" }, " Contact us ", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "_content" }, [
  /*#__PURE__*/_createElementVNode("p", null, " If you have any questions about our terms, policies, or other technologies, please email contact us via: "),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "mailto:help.gochase.me@gmail.com" }, "Email")
  ])
], -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_IconButton, {
          icon: "back",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({path:'/app'}))),
          white: true
        })
      ]),
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _hoisted_13,
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: "/policy/terms" }, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: "/policy/cookie" }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: "/policy/privacy" }, {
              default: _withCtx(() => [
                _hoisted_16
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, { to: "/policy/pwa" }, {
              default: _withCtx(() => [
                _hoisted_17
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _hoisted_18,
      _hoisted_19
    ])
  ]))
}